//预加载图片资源,活动弹窗
export default [
    require("@/assets/sound/hall/hallBgm.mp3"),
    require("@/assets/sound/hall/click.mp3")
]